.clickableWrapper:hover:not(.disabled) {
  cursor: pointer;
}
